import React from 'react';
import classnames from 'classnames';
import { withMatureContext } from '@wix/da-react-context/pkg/MatureContext';
import s from './LegacyTextRenderer.scss';
function createMarkup(text) {
    return { __html: text };
}
export var LegacyTextRenderer = React.forwardRef(function (_a, ref) {
    var html = _a.html, className = _a.className, theme = _a.theme, showMatureContent = _a.showMatureContent, disableStyles = _a.disableStyles;
    if (!html) {
        return null;
    }
    return (React.createElement("div", { className: classnames('legacy-journal', !disableStyles && theme && s['legacy'], !disableStyles && theme && s[theme], !showMatureContent && 'maturefilter', className), dangerouslySetInnerHTML: createMarkup(html), ref: ref }));
});
LegacyTextRenderer.displayName = 'LegacyTextRenderer';
export default withMatureContext(LegacyTextRenderer);
//# sourceMappingURL=LegacyTextRenderer.js.map